// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__y1iIq","loadingShrink":"PageLoading_loadingShrink__HlPbk"};